module.exports = __webpack_public_path__ + "static/media/app_2.0225f05f.png";